<div class="container mt-3">
  <div class="d-flex align-items-center justify-content-between mb-2">
    <h3 class="mb-0">Brand Mapping Management</h3>
    <button class="btn btn-outline-secondary btn-sm" (click)="goBack()">
      Back to Mapping
    </button>
  </div>

  <div class="row g-2 mb-3">
    <div class="col-md-4">
      <div ngbDropdown class="d-inline-block w-100">
        <button class="btn btn-outline-primary w-100" ngbDropdownToggle>
          {{ selectedVendorName }}
        </button>
        <div ngbDropdownMenu>
          <button *ngFor="let vendor of vendors" class="dropdown-item" (click)="selectVendor(vendor.vendorId)">
            {{ vendor.name }}
          </button>
        </div>
      </div>
    </div>
    <div class="col-md-4">
      <div ngbDropdown class="d-inline-block w-100">
        <button class="btn btn-outline-primary w-100" ngbDropdownToggle>
          {{ selectedBrandName }}
        </button>
        <div ngbDropdownMenu class="brand-dropdown-menu">
          <div class="px-2 py-2">
            <input class="form-control" type="search" [(ngModel)]="brandSearchTerm" placeholder="Search brands..."
              (input)="filterBrands()" />
          </div>
          <button *ngFor="let brand of filteredBrands" class="dropdown-item" (click)="selectBrand(brand)">
            {{ brand.name }}
          </button>
        </div>
      </div>
    </div>
    <div class="col-md-4 text-end">
      <button class="btn btn-primary" (click)="createAllForBrand()" [disabled]="isLoading || !selectedBrand">
        Create mappings for all sizes
      </button>
    </div>
  </div>

  <div *ngIf="statusMessage" class="alert alert-info py-2">
    {{ statusMessage }}
  </div>

  <div class="card">
    <div class="card-body p-0">
      <table class="table table-striped mb-0">
        <thead>
          <tr>
            <th style="width: 40px;">
              <input type="checkbox" class="form-check-input" [checked]="selectAllEligibleChecked"
                [disabled]="selectAllEligibleDisabled" (change)="toggleSelectAll($any($event.target).checked)"
                title="Select all eligible sizes" aria-label="Select all eligible sizes" />
            </th>
            <th>Vendor Size</th>
            <th>Size Type</th>
            <th>Gender</th>
            <th>Current General Mapping</th>
            <th>Current Brand Mapping</th>
            <th class="text-nowrap">Status</th>
            <th class="actions-col text-nowrap">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let size of vendorSizes">
            <td>
              <input type="checkbox" [checked]="isSelected(size)" [disabled]="!canCreateBrandMapping(size)"
                (change)="toggleSelection(size, $any($event.target).checked)" />
            </td>
            <td>{{ size.idName }}</td>
            <td>{{ $any(size).sizeTypeName || '-' }}</td>
            <td>{{ $any(size).genderName || '-' }}</td>
            <td>{{ size.systemItemValue || '-' }}</td>
            <td>{{ $any(size).brandSpecificSystemItemValue || 'n/a' }}</td>
            <td class="text-nowrap">
              <span class="badge bg-success" *ngIf="isGeneralMapped(size)">General mapped</span>
              <span class="badge bg-secondary" *ngIf="!isGeneralMapped(size)">Not mapped</span>
              <span class="badge bg-primary text-white ms-1" *ngIf="isBrandMapped(size)">Brand mapped</span>
            </td>
            <td class="actions-col">
              <div class="d-flex gap-2 flex-nowrap">
                <button class="btn btn-sm btn-outline-success text-nowrap" (click)="createBrandSpecific(size)"
                  [disabled]="!canCreateBrandMapping(size)">
                  Create brand mapping
                </button>
                <button class="btn btn-sm btn-outline-danger text-nowrap" (click)="deleteBrandSpecific(size)"
                  [disabled]="!hasBrandSpecificMappingRow(size)">
                  Delete brand mapping
                </button>
              </div>
            </td>
          </tr>
          <tr *ngIf="!vendorSizes.length && !isLoading">
            <td colspan="8" class="text-center py-3">No sizes available for selected vendor.</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>